import { render, staticRenderFns } from "./suratperingatan.vue?vue&type=template&id=21e2e9ca&"
import script from "./suratperingatan.vue?vue&type=script&lang=js&"
export * from "./suratperingatan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports